import * as React from 'react';
import { createComponent } from '@lit/react';
import { AuthWC } from './auth.wc';

export const Auth = createComponent({
  tagName: AuthWC.tagname,
  elementClass: AuthWC,
  react: React,
});
